/**
 * ConflictStep Component
 *
 * Displays conflict resolution UI when conflicts are detected.
 */

import React from "react";
import classNames from "classnames";
import { ActionButton } from "@/components/ui/buttons/ActionButton";
import { Spinner } from "@/components/ui/feedback/Spinner";
import type { ConflictStepProps } from "../types";
import styles from "../EditForm.module.css";

export const ConflictStep: React.FC<ConflictStepProps> = ({
  conflictResolution,
  onCancel,
  onResolve,
  className,
  "data-testid": testId,
}) => {
  return (
    <div
      className={classNames(styles.container, className)}
      data-testid={testId}
    >
      <div className={styles.conflictStep} data-testid="edit-form-conflict">
        {conflictResolution.isLoading ? (
          <div className={styles.loadingContainer}>
            <Spinner size="md" />
            <span className={styles.loadingText}>Sjekker konflikter...</span>
          </div>
        ) : conflictResolution.hasConflicts ? (
          <div data-testid="edit-form-has-conflicts">
            <p className={styles.editHint}>
              Konflikter oppdaget. Løs konflikter før du lagrer.
            </p>
            {/* ConflictResolver component would be rendered here */}
            <div className={styles.actions}>
              <ActionButton
                label="Avbryt"
                icon="x"
                variant="secondary"
                onClick={onCancel}
                data-testid="edit-form-conflict-cancel"
              />
              <ActionButton
                label="Lagre likevel"
                icon="check"
                onClick={onResolve}
                disabled={conflictResolution.allOmitted}
                data-testid="edit-form-conflict-save"
              />
            </div>
          </div>
        ) : (
          <div className={styles.actionsEnd}>
            <ActionButton
              label="Avbryt"
              icon="x"
              variant="secondary"
              onClick={onCancel}
              data-testid="edit-form-conflict-cancel"
            />
            <ActionButton
              label="Lagre"
              icon="check"
              onClick={onResolve}
              data-testid="edit-form-conflict-save"
            />
          </div>
        )}
      </div>
    </div>
  );
};

ConflictStep.displayName = "ConflictStep";

export default ConflictStep;
